import { render, staticRenderFns } from "./AddOrEditCatalog.vue?vue&type=template&id=d052dcd4&scoped=true&"
import script from "./AddOrEditCatalog.vue?vue&type=script&lang=js&"
export * from "./AddOrEditCatalog.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditCatalog.vue?vue&type=style&index=0&id=d052dcd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d052dcd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VAvatar,VCard,VCardText,VCardTitle,VCheckbox,VCol,VRow,VTextField})
